import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import {
  ASSET_SELECTION_GRID_STATE,
  ASSET_SELECTION_GRID_STATE_REMOVE,
  ASSET_SELECTION_GRID_STATE_SET,
} from '../../shared/constants';
import { KendoGridFilters, SortInputModel } from '../../../awsAppSync/API';
import { State as KendoState } from '@progress/kendo-data-query';

// ---------- Actions ----------
export class SetAssetSelectionGridState {
  static readonly type = ASSET_SELECTION_GRID_STATE_SET;
  constructor(
    public gridState: KendoState,
    public kendoGridFilters: KendoGridFilters | null,
    public sortInput: SortInputModel | null,
  ) {}
}

export class RemoveAssetSelectionGridState {
  static readonly type = ASSET_SELECTION_GRID_STATE_REMOVE;
}

// ---------- State Model ----------
export interface AssetSelectionGridStateModel {
  gridState: KendoState | null;
  kendoGridFilters: KendoGridFilters | null;
  sortInput: SortInputModel | null;
}

// ---------- NGXS State ----------
@State<AssetSelectionGridStateModel>({
  name: ASSET_SELECTION_GRID_STATE,
  defaults: {
    gridState: null,
    kendoGridFilters: null,
    sortInput: null,
  },
})
@Injectable()
export class AssetSelectionGridState {
  @Selector()
  static getGridState(state: AssetSelectionGridStateModel) {
    return state;
  }

  @Action(SetAssetSelectionGridState)
  setGridState(
    { patchState }: StateContext<AssetSelectionGridStateModel>,
    { gridState, kendoGridFilters, sortInput }: SetAssetSelectionGridState,
  ): void {
    patchState({ gridState, kendoGridFilters, sortInput });
  }

  @Action(RemoveAssetSelectionGridState)
  removeGridState({
    setState,
  }: StateContext<AssetSelectionGridStateModel>): void {
    setState({ gridState: null, kendoGridFilters: null, sortInput: null });
  }
}
